import { useMemo, FC, CSSProperties } from 'react'
import cn from 'classnames'
import { ImageURLs, ImageSource } from 'interfaces/media'
import styles from 'components/features/pfm/AdjustableImage/AdjustableImage.styl'
import { LazyRender } from 'components/features/pfm/LazyRender/LazyRender'
import AdjustableImageContent from 'components/features/pfm/AdjustableImage/AdjustableImageContent'

/*
TODO:
1. Lazy load - DONE
2. Handle errors
3. Fallback to original
4. Fallback passed with prop
*/

export type AdjustableImageProps = {
  image?: ImageURLs | null
  preventBackground?: boolean
  preventLazyRender?: boolean
  fitToContainer?: boolean
  imageClassName?: string
  onImageFound?: (image: ImageSource) => void
  onClick?: () => void
}

const AdjustableImage: FC<AdjustableImageProps> = ({
  children,
  preventBackground = false,
  preventLazyRender = false,
  fitToContainer = false,
  imageClassName,
  onClick,
  image,
  onImageFound,
}) => {
  const imageSource = image ? image.sources[0] : null

  const containerStyles = useMemo<CSSProperties>(() => {
    if (!imageSource || fitToContainer) {
      return {}
    }

    return {
      paddingTop: `${ (imageSource.height / imageSource.width * 100) }%`,
    }
  }, [imageSource, fitToContainer])

  const containerClassName = useMemo(() => cn(
    styles.container,
    {
      [styles.fitToContainer]: fitToContainer,
    }
  ), [fitToContainer])

  const imageChild = useMemo(() => (
    <AdjustableImageContent
      image={ image }
      onImageFound={ onImageFound }
      className={ cn(styles.image, imageClassName) }
    />
  ), [image, onImageFound, imageClassName])

  return (
    <div
      style={ containerStyles }
      onClick={ onClick }
      className={ containerClassName }
    >
      { !preventBackground && !preventLazyRender && (
        <LazyRender className={ styles.lazy } margin={ 100 }>
          { imageChild }
        </LazyRender>
      )}
      { !preventBackground && preventLazyRender && imageChild }
      <div className={ styles.content }>
        { children }
      </div>
    </div>
  )
}
export default AdjustableImage
